module.exports = __webpack_public_path__ + "static/frial-bg-a7e46fe4965a519d77fda4033602156a.png";